import { useEffect, useRef, useState } from 'react';
import menuPhotos from '../assets/menuImages';
import { getImageSrc } from '../utils/imageAssets';
import { PROMO_VIDEO } from '../config/promo';
import { PauseIcon, PlayIcon, VolumeIcon, VolumeMuteIcon } from './Icons';

function PromoSpace() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [volume, setVolume] = useState(0.6);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;

    const nextMuted = !isMuted;
    video.muted = nextMuted;
    setIsMuted(nextMuted);
  };

  const handleVolumeChange = (event) => {
    const video = videoRef.current;
    if (!video) return;

    const nextVolume = Number(event.target.value);
    video.volume = nextVolume;
    setVolume(nextVolume);

    if (nextVolume === 0) {
      video.muted = true;
      setIsMuted(true);
    } else {
      video.muted = false;
      setIsMuted(false);
    }
  };

  const handleVideoEnd = () => setIsPlaying(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;
    video.play()
      .then(() => setIsPlaying(true))
      .catch(() => setIsPlaying(false));
  }, []);

  return (
    <section className="promo-space" aria-label="Espace publicitaire">
      <div className="promo-space-inner">
        <div className="promo-space-media">
          <div className="promo-space-video">
            <video
              ref={videoRef}
              autoPlay
              muted={isMuted}
              loop
              playsInline
              preload="auto"
              poster={getImageSrc(menuPhotos.burgers)}
              src={PROMO_VIDEO.mp4Url}
              controlsList="nodownload noplaybackrate nofullscreen"
              disablePictureInPicture
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={handleVideoEnd}
              aria-label="Vidéo de confection de burger DoWhile Food"
            />

            <div className="promo-video-controls">
              <button
                type="button"
                className="promo-control-btn"
                onClick={togglePlay}
                aria-label={isPlaying ? 'Mettre en pause' : 'Lire la vidéo'}
              >
                {isPlaying ? <PauseIcon size={16} /> : <PlayIcon size={16} />}
              </button>

              <div className="promo-volume-wrap">
                <button
                  type="button"
                  className="promo-control-btn"
                  onClick={toggleMute}
                  aria-label={isMuted ? 'Activer le son' : 'Couper le son'}
                >
                  {isMuted || volume === 0 ? <VolumeMuteIcon size={16} /> : <VolumeIcon size={16} />}
                </button>

                <div className="promo-volume-popup">
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.05"
                    value={volume}
                    onChange={handleVolumeChange}
                    className="promo-volume-slider"
                    aria-label="Régler le volume"
                  />
                </div>
              </div>
            </div>
          </div>
          <p className="promo-space-caption">
            DoWhile Food, votre adresse gourmande à Yaoundé
          </p>
        </div>

        <div className="promo-space-content">
          <p className="promo-space-tag">Espace publicitaire</p>
          <h2 className="promo-space-title">
            Le goût DoWhile Food,<br />
            <span>préparé devant vos yeux</span>
          </h2>
          <p className="promo-space-text">
            Chaque burger est assemblé avec soin : pain frais, steak juteux, fromage fondant
            et sauce maison. Découvrez l&apos;art de la confection comme dans nos cuisines
            à Yaoundé.
          </p>
          <p className="promo-space-text">
            Composez votre repas en ligne, ajoutez vos ingrédients préférés et commandez
            en quelques clics pour savourer le même plaisir chez vous.
          </p>
        </div>
      </div>
    </section>
  );
}

export default PromoSpace;
